import {useCallback, useEffect, useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";

const getBrowserLocation = () => {
    if (typeof window === "undefined") {
        return null;
    }

    return `${window.location.pathname}${window.location.search}`;
};

const useBackNavigation = (fallbackLink) => {
    const navigate = useNavigate();
    const location = useLocation();
    const lastKnownLocationRef = useRef(`${location.pathname}${location.search}`);
    const isMountedRef = useRef(true);

    useEffect(() => {
        lastKnownLocationRef.current = `${location.pathname}${location.search}`;
    }, [location.pathname, location.search]);

    useEffect(() => () => {
        isMountedRef.current = false;
    }, []);

    return useCallback(() => {
        const snapshot = lastKnownLocationRef.current;

        navigate(-1);

        if (!fallbackLink) {
            return;
        }

        setTimeout(() => {
            if (!isMountedRef.current) {
                return;
            }

            const browserLocation = getBrowserLocation();

            if (browserLocation === snapshot) {
                navigate(fallbackLink);
            }
        }, 150);
    }, [navigate, fallbackLink]);
};

export default useBackNavigation;
